import styled from 'styled-components'

import { textStyle } from 'styles/text-style'

type Props = ISpan & {
  id?: string
}

export const Li = styled.li<Props>`
  ${textStyle}
`
